import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2 } from "lucide-react";

const glass = "rounded-2xl border border-white/10 bg-white/[0.04] backdrop-blur-xl";

export default function ChangePassword() {
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (next !== confirm) { setError("New passwords do not match"); return; }
    if (next.length < 6) { setError("New password must be at least 6 characters"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: current, new_password: next });
      toast.success("Password updated");
      navigate("/");
    } catch (err) {
      setError(apiErr(err.response?.data?.detail) || err.message);
    }
    setLoading(false);
  };

  const inp = "mt-1.5 bg-[#0B0F17] border-[#374151] text-white";

  return (
    <div className="max-w-lg">
      <div className="text-xs font-mono uppercase tracking-widest text-emerald-400 mb-1">Account</div>
      <h1 className="font-[Outfit] font-bold text-3xl sm:text-4xl tracking-tight mb-6">Change Password</h1>
      <form onSubmit={submit} className={`${glass} p-6 space-y-4`} data-testid="change-password-form">
        <div className="flex items-center gap-2 text-emerald-400 text-sm mb-2"><KeyRound className="w-4 h-4" /> Update your sign-in password</div>
        {error && <div className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2" data-testid="change-password-error">{error}</div>}
        <div>
          <Label className="text-[#9CA3AF]">Current password</Label>
          <Input type="password" required data-testid="current-password-input" value={current} onChange={(e) => setCurrent(e.target.value)} className={inp} />
        </div>
        <div>
          <Label className="text-[#9CA3AF]">New password</Label>
          <Input type="password" required minLength={6} data-testid="new-password-input" value={next} onChange={(e) => setNext(e.target.value)} className={inp} />
        </div>
        <div>
          <Label className="text-[#9CA3AF]">Confirm new password</Label>
          <Input type="password" required data-testid="confirm-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={inp} />
        </div>
        <Button type="submit" disabled={loading} data-testid="change-password-submit" className="bg-emerald-500 hover:bg-emerald-400 text-black font-semibold">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Update password"}
        </Button>
      </form>
    </div>
  );
}
